// @flow

import React from 'react';
import { connect } from 'react-redux';
import { isLoading as isLoadingSelector } from '../../store/routes';
import StyledLoader from './loader.styled';

type OwnProps = {|
  LoaderComponent?: any,
  alwaysLoading?: boolean,
|};

type StateProps = {|
  isLoading: boolean,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Loader = ({
  isLoading,
  LoaderComponent,
  alwaysLoading,
}: Props) => {
  if (LoaderComponent) {
    return (
      <LoaderComponent isLoading={isLoading || alwaysLoading} />
    );
  }
  return null;
};

Loader.defaultProps = {
  LoaderComponent: StyledLoader,
  alwaysLoading: false,
};

const mapStateToProps = (state): StateProps => ({
  isLoading: isLoadingSelector(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(Loader);
